module.exports = __webpack_public_path__ + "8bda67d54a9e87f61a509912ea7df1ba.jpeg";